import { Body, Controller, Param, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { EmployeeService } from "./employee.services";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { EmployeeDto } from "./employee.dto";
import { EmployeePhoneNoReq } from "./employee-phone-no.req";

@Controller('employee')
@ApiTags('/employee')
export class EmployeeController {
    constructor(private service: EmployeeService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllEmployee')
    async getAllEmployee(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllEmployee(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createEmployee')
    @ApiBody({ type: EmployeeDto })
    async createEmployee(@Body() req: any): Promise<CommonResponseModel> {
        try {
            console.log(req, 'ppppppppppp');

            return await this.service.createEmployee(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllEmployee')
    async getActiveAllEmployee(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllEmployee();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateEmployee')
    @ApiBody({ type: EmployeeDto })
    async updateEmployee(@Body() req: any): Promise<CommonResponseModel> {
        console.log("controller", req)
        try {


            return await this.service.updateEmployee(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateEmployee')
    @ApiBody({ type: EmployeeDto })
    async activateOrDeactivateEmployee(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateEmployee(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }
    @Post("/getEmployeeDashBoard")
    async getEmployeeDashBoard(): Promise<CommonResponseModel> {
      try {
        return await this.service.getEmployeeDashBoard();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(
          CommonResponseModel,
          error
        );
      }
    }

    @Post("/getHods")
    async getHods(): Promise<CommonResponseModel> {
      try {
        return await this.service.getHods();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(
          CommonResponseModel,
          error
        );
      }
    }

    @Post("/getNonHods")
    async getNonHods(): Promise<CommonResponseModel> {
      try {
        return await this.service.getNonHods();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(
          CommonResponseModel,
          error
        );
      }
    }

    @Post("/checkIfEmployeeExist")
    @ApiBody({ type: EmployeePhoneNoReq })
    async checkIfEmployeeExist(@Body() req:any) {
      try {
        return await this.service.checkIfEmployeeExist(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(
          CommonResponseModel,
          error
        );
      }
    }


    @Post("/getHodDetailsByEmp")
    @ApiBody({ type: EmployeePhoneNoReq })
    async getHodDetailsByEmp(@Body() req:any) {
      try {
        return await this.service.getHodDetailsByEmp(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(
          CommonResponseModel,
          error
        );
      }
    }

    @Post('/getEmployeeById')
    async getEmployeeById(@Body() req:any):Promise<CommonResponseModel>{
        try{
            return await this.service.getEmployeeById(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponseModel,err)
        }
    }
    //employee dump & user creation dont delete
    // @Post('/saveOrder')
    // async saveOrder(@Body() data: any): Promise<CommonResponseModel> {
    //     try {
    //         return this.service.createEmloyeeAndUser(data);
    //     } catch (err) {
    //         return this.applicationExceptionHandler.returnException(CommonResponseModel, err);

    //     }
    // }

    //employee dump & user creation dont delete
    // @Post("/updatePassword")
    // async updatePassword(): Promise<CommonResponseModel> {
    //   try {
    //     return await this.service.updatePassword();
    //   } catch (error) {
    //     return this.applicationExceptionHandler.returnException(
    //       CommonResponseModel,
    //       error
    //     );
    //   }
    // }

}